import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
// import CorrectVocabulary from "./pages/games/CorrectVocabulary/CorrectVocabulary";
import GamesPage from "./pages/games/Games";
import WeatherApp from "./pages/weatherApp/WeatherApp";
import AppsPage from "./pages/apps/Apps";
import AboutPage from "./pages/about/About";
import NFTsPage from "./pages/NFT/NFT";
import ERROR_500 from "./pages/error_500/Error_500";
import PrivacyPolicy from "./pages/privacy_policy/PrivacyPolicy";
import NFTDetails from "./pages/NFTDetails/NFTDetails";
import SellNFT from "./pages/sellNFT/SellNFT";
import GamesVideo from "./pages/games_video/Game_Video";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  // {
  //   path: "CorrectVocabulary",
  //   element: <CorrectVocabulary />,
  // },
  {
    path: "Games",
    element: <GamesPage />,
  },
  {
    path: "WeatherApp",
    element: <WeatherApp />,
  },
  {
    path: "AppsPage",
    element: <AppsPage />,
  },
  {
    path: "GamesVideo",
    element: <GamesVideo />,
  },
  {
    path: "NFT",
    element: <NFTsPage />,
  },
  {
    path: "NFTDetails",
    element: <NFTDetails />,
  },
  {
    path: "SellNFT",
    element: <SellNFT />,
  },
  {
    path: "About",
    element: <AboutPage />,
  },
  {
    path: "Error_500",
    element: <ERROR_500 />,
  },
  {
    path: "Privacy_Policy",
    element: <PrivacyPolicy />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
document.getElementById("loading_page")?.remove();
